import React from 'react'

const Rings = () => {
  return (
    <div>Rings</div>
  )
}

export default Rings